/* Adds to the cart without a page load and hands the result to Dawn's cart
   drawer.

   Failure handling is deliberately split: if the add itself fails nothing is in
   the cart, so the browser's own form POST is a safe retry. If the add
   succeeded but the drawer could not be rendered, re-submitting would add the
   item a second time, so we navigate to the cart page instead. */
(function () {
  var SELECTOR = '.bl-card__form, .bl-pdp__form';

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest(SELECTOR);
    if (!form || form.hasAttribute('data-bl-busy')) return;

    var cd = document.querySelector('cart-drawer');
    if (!cd || typeof cd.renderContents !== 'function') return;

    e.preventDefault();
    form.setAttribute('data-bl-busy', '');

    var button = form.querySelector('[type="submit"]');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    var release = function () {
      form.removeAttribute('data-bl-busy');
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    };

    var body = new FormData(form);
    body.delete('sections');
    body.delete('sections_url');
    body.append('sections', cd.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    body.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          // nothing was added — let the browser submit the form normally
          release();
          form.submit();
          return;
        }
        try {
          // Dawn's renderContents only clears `is-empty` from .drawer__inner. If it
          // stays on <cart-drawer>, open() looks for .drawer__inner-empty, which the
          // fresh markup no longer has, and the focus trap throws.
          cd.classList.remove('is-empty');
          cd.renderContents(res.json);
          release();
        } catch (err) {
          // the item is in the cart; never re-submit, just show it
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        release();
        form.submit();
      });
  });
})();
